import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Urls from '../../../utils/urls';
import BaseUrls from '../../../utils/baseUrls';
import apiBackendInstance from '../../../utils/axios';

export type NetworkInviteDataDB = {
    id?: string,
    network_id?: string,
    network_name: string,
    status: number,
    protocol_id?: string,
    sender_email: string,
    reciever_email: string,
    redirection_url: string,
    created_at: string,
    updated_at?: string
  };

export type NetworkData = {
    type: string;
    id: string;
    name: string;
    protocolId: string;
    workspaceId: string;
    inProgressNodes: number;
    activeNodes: number;
    inactiveNodes: number;
    frontendBaseSuburl: string;
    protocolName: string;
    createdAt: string;
  }
  interface Ticket {
    url: string;
    id: number;
    external_id: null | string;
    via: {
      channel: string;
      source: {
        from: {
          address: string;
          name: string;
        };
        to: {
          name: string;
          address: string;
        };
        rel: null | string;
      };
    };
    created_at: string;
    updated_at: string;
    type: null | string;
    subject: string;
    raw_subject: string;
    description: string;
    priority: null | string;
    status: string;
    recipient: string;
    requester_id: number;
    submitter_id: number;
    assignee_id: number;
    organization_id: null | string;
    group_id: number;
    collaborator_ids: number[];
    follower_ids: number[];
    email_cc_ids: number[];
    forum_topic_id: null | string;
    problem_id: null | string;
    has_incidents: boolean;
    is_public: boolean;
    due_at: null | string;
    tags: string[];
    custom_fields: any[];
    satisfaction_rating: null | string;
    sharing_agreement_ids: number[];
    custom_status_id: number;
    fields: any[];
    followup_ids: number[];
    ticket_form_id: number;
    brand_id: number;
    allow_channelback: boolean;
    allow_attachments: boolean;
    from_messaging_channel: boolean;
    result_type: string;
  }

  interface TicketData {
    results: Ticket[];
    facets: null;
    next_page: null | string;
    previous_page: null | string;
    count: number;
  }

const SystemHealth = () => {
  const theme = BaseUrls.getkey();
  const resource1 = `img/${theme}/activenodes.png`;
  const resource2 = `img/${theme}/Ticket.png`;
  const resource3 = `img/${theme}/Danger.png`;
  const resource6 = `img/${theme}/Ticket-close.png`;
  const resource7 = `img/${theme}/Danger-fatal.png`;
  const resource8 = `img/${theme}/pending invites.png`;

  const [tdata, setTData] = useState([] as NetworkInviteDataDB[]);
  const getAllNetworkInviteList = () => {
    apiBackendInstance.get(Urls.getNetworkInviteList(0), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data) {
        setTData(response.data.data);
      }
    })
      .catch((err) => {
        setTData([]);
        console.error(err);
      });
  };

  useEffect(() => {
    getAllNetworkInviteList();
  }, []);

  const [waringAlertsData, setWaringAlertsData] = useState<number>(0);
  const [criticalAlerts, setCriticalAlerts] = useState<number>(0);
  const playload = {
    fields: {
      networkId: [],
    },
  };
  const fetchAlertsData = async () => {
    apiBackendInstance.post(Urls.getAllAlertsCount(), { ...playload }, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data[0]) {
        setWaringAlertsData(response.data.data[0].waringAlerts);
        setCriticalAlerts(response.data.data[0].criticalAlerts);
      }
    })
      .catch((err) => {
        setWaringAlertsData(0);
        setCriticalAlerts(0);
        console.error(err);
      });
  };

  useEffect(() => {
    fetchAlertsData();
  }, [waringAlertsData, criticalAlerts]);

  const [activeFullNodesNumber, setActiveFullNodesNumber] = useState<number>(0);
  const fetchActiveFullNodes = async () => {
    try {
      const response = await apiBackendInstance.get(Urls.getActiveFullNode(), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const getActiveFullNodesCount = (data: NetworkData[]): number => {
        let count = 0;
        data.forEach((item) => {
          count += item.activeNodes;
        });
        return count;
      };
      if (response && response.data && response.data.data) {
        const activeNodesCount: number = getActiveFullNodesCount(response.data.data);
        setActiveFullNodesNumber(activeNodesCount);
      }
    } catch (error) {
      setActiveFullNodesNumber(0);
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchActiveFullNodes();
  }, [activeFullNodesNumber]);

  const [activeValidatorNodesNumber, setActiveValidatorNodesNumber] = useState<number>(0);
  const fetchActiveValidatorNodes = async () => {
    try {
      const response = await apiBackendInstance.get(Urls.getActiveValidatorNode(), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const getActiveValidatorNodesCount = (data: NetworkData[]): number => {
        let count = 0;
        data.forEach((item) => {
          count += item.activeNodes;
        });
        return count;
      };
      if (response && response.data && response.data.data) {
        const activeNodesCount: number = getActiveValidatorNodesCount(response.data.data);
        setActiveValidatorNodesNumber(activeNodesCount);
      }
    } catch (error) {
      setActiveValidatorNodesNumber(0);
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchActiveValidatorNodes();
  }, [activeValidatorNodesNumber]);

  const [userEmail, setUserEmail] = useState<string>('');
  const getUserEmail = async () => {
    try {
      const response = await apiBackendInstance.get(Urls.getUserInfo(), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (response && response.data && response.data.data && response.data.data.usercred) {
        setUserEmail(response.data.data.usercred);
      }
    } catch (error) {
      setUserEmail('');
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    getUserEmail();
  }, []);
  const [openTickets, setOpenTickets] = useState<number>(0);
  const [closedTickets, setClosedTickets] = useState<number>(0);
  const subdomain = 'none8833';
  const openTicketsURL = `https://${subdomain}.zendesk.com/hc/en-us/requests?utf8=%E2%9C%93&query=&status=open`;
  const closeTicketURL = `https://${subdomain}.zendesk.com/hc/en-us/requests?utf8=%E2%9C%93&query=&status=solved`;
  const fetchDataFromZendeskAPI = async () => {
    const zendeskAPI = `https://${subdomain}.zendesk.com/api/v2/search.json?query=requester:${userEmail}`;
    const config = {
      headers: {
        Authorization: 'Bearer 81b965fec36de0963900e73393e5fe4cbec9cdb008dc68180f2b4856b250e599',
      },
    };

    try {
      const response = await axios.get(zendeskAPI, config);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch data from the Zendesk API');
    }
  };
  const findStatusCount = async (data: TicketData, status: string): Promise<number> => {
    let count = 0;
    data.results.forEach((ticket) => {
      if (ticket.status === status) {
        count += 1;
      }
    });
    return count;
  };

  const main = async () => {
    try {
      const data = await fetchDataFromZendeskAPI();
      const openCount: number = await findStatusCount(data, 'open');
      setOpenTickets(openCount);
      const solvedCount: number = await findStatusCount(data, 'solved');
      setClosedTickets(solvedCount);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    main();
  });

  return (
        <div className="card p-3">
            <div className="card-body mt-1 mb-1">
                <div className="d-flex">
                    <div className="col-xl-6 col-lg-6 col-md-5 col-sm-4">
                        <h5>System Data</h5>
                    </div>
                </div>
                <div className="mt-2 mb-2 row">
                    <div className=" col-xl-3 col-lg-3 col-md-5 col-sm-5 mx-auto ">
                        <div
                          className="d-flex text-styling align-items-center p-2 "
                          style={{ textDecoration: 'none', color: 'black' }}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              window.location.href = BaseUrls.getPlatformDedicatedFullNodesUrl();
                            }
                          }}
                          onClick={() => window.location.href = BaseUrls.getPlatformDedicatedFullNodesUrl()}
                        >
                            <div className="col-4">
                                <img src={resource1} alt="" />
                            </div>
                            <div className="col-6">
                            <p className="mb-0"><strong><h6>Active Node</h6></strong></p>
                            <p className="mb-0"><strong><h6>(Full Nodes)</h6></strong></p>
                            </div>
                            <div className="col-4 ">
                                <p className="mb-0"><h6>{activeFullNodesNumber === 0 ? '00' : activeFullNodesNumber}</h6></p>
                            </div>
                        </div>
                    </div>
                    <div className=" col-xl-3 col-lg-3 col-md-5 col-sm-5 mx-auto ">
                        <div
                          className="d-flex text-styling align-items-center p-2 cursor"
                          style={{ textDecoration: 'none', color: 'black' }}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              window.location.href = BaseUrls.getPlatformDedicatedValidatorNodesUrl();
                            }
                          }}
                          onClick={() => window.location.href = BaseUrls.getPlatformDedicatedValidatorNodesUrl()}
                        >
                            <div className="col-4">
                                <img src={resource1} alt="" />
                            </div>
                            <div className="col-6">
                            <p className="mb-0"><strong><h6>Active Node</h6></strong></p>
                            <p className="mb-0"><strong><h6>(Validator Nodes)</h6></strong></p>
                            </div>
                            <div className="col-4 ">
                                <p className="mb-0"><h6>{activeValidatorNodesNumber === 0 ? '00' : activeValidatorNodesNumber}</h6></p>
                            </div>
                        </div>
                    </div>
                    <div className=" col-xl-3 col-lg-3 col-md-5 col-sm-5 mx-auto ">
                        <a
                        href={openTicketsURL}
                        target="_blank"
                        rel="noreferrer"
                        className="d-flex text-styling align-items-center p-2 "
                        style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <div className="col-4">
                                <img src={resource2} alt="" />
                            </div>
                            <div className="col-6">
                            <p className="mb-0"><strong><h6>Open Tickets</h6></strong></p>
                            </div>
                            <div className="col-4 ">
                                <p className="mb-0"><h6>{openTickets === 0 ? '00' : openTickets}</h6></p>
                            </div>
                        </a>
                    </div>
                    <div className=" col-xl-3 col-lg-3 col-md-5 col-sm-5 mx-auto ">
                        <a
                        href={closeTicketURL}
                        target="_blank"
                        rel="noreferrer"
                        className="d-flex text-styling align-items-center p-2 "
                        style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <div className="col-4">
                                <img src={resource6} alt="" />
                            </div>
                            <div className="col-6">
                            <p className="mb-0"><strong><h6>Closed Tickets</h6></strong></p>
                            </div>
                            <div className="col-4 ">
                                <p className="mb-0"><h6>{closedTickets === 0 ? '00' : closedTickets}</h6></p>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="mt-2 mb-2 row">
                    <div className=" col-xl-3 col-lg-3 col-md-5 col-sm-5 mx-auto ">
                        <Link
                        to="/app/Alerts"
                        className="d-flex text-styling align-items-center p-2 cursor"
                        style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <div className="col-4">
                                <img src={resource3} alt="" />
                            </div>
                            <div className="col-6">
                            <p className="mb-0"><strong><h6>Warning Alerts</h6></strong></p>
                            </div>
                            <div className="col-4 ">
                                <p className="mb-0"><h6>{waringAlertsData === null ? '00' : waringAlertsData}</h6></p>
                            </div>
                        </Link>
                    </div>
                    <div className=" col-xl-3 col-lg-3 col-md-5 col-sm-5 mx-auto ">
                        <Link
                        to="/app/Alerts"
                        className="d-flex text-styling align-items-center p-2 cursor"
                        style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <div className="col-4">
                                <img src={resource7} alt="" />
                            </div>
                            <div className="col-6">
                            <p className="mb-0"><strong><h6>Critical Alerts</h6></strong></p>
                            </div>
                            <div className="col-4 ">
                                <p className="mb-0"><h6>{criticalAlerts === null ? '00' : criticalAlerts}</h6></p>
                            </div>
                        </Link>
                    </div>
                    <div className=" col-xl-3 col-lg-3 col-md-5 col-sm-5 mx-auto ">
                        <Link
                        to="/app/Account"
                        state={{ value: 'networkInvite' }}
                        className="d-flex text-styling align-items-center p-2 cursor"
                        style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <div className="col-4">
                                <img src={resource8} alt="" />
                            </div>
                            <div className="col-6">
                            <p className="mb-0"><strong><h6>Pending Invites</h6></strong></p>
                            </div>
                            <div className="col-4 ">
                                <p className="mb-0"><h6>{ tdata.length === 0 ? '00' : tdata.length }</h6></p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
  );
};
export default SystemHealth;
